import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import html2canvas from 'html2canvas';
import download from 'downloadjs';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';

type TextFieldData = {
  text: string;
  x: number;
  y: number;
  width: number;
  height: number;
  fontFamily: string;
  fontSize: number;
};

const getBase64StringFromDataURL = dataURL => {
  return dataURL.replace('data:', '').replace(/^.+,/, '');
};

async function getImgSrcAsBase64String(imgSrc) {
  const response = await fetch(imgSrc);
  const blob = await response.blob();

  const p = new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // Convert to Base64 string
      const base64 = getBase64StringFromDataURL(reader.result);
      if (base64) {
        resolve(base64);
      }

      reject('no has base64');
    };

    reader.readAsDataURL(blob);
  });

  return p;
}

function base64ToArrayBuffer(base64) {
  var binaryString = atob(base64);
  var bytes = new Uint8Array(binaryString.length);
  for (var i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // return
      resolve(reader.result);
    };

    reader.readAsDataURL(blob);
  });
}

async function generatePDFFromCanvas({
  imgSize,
  scale,
  id,
  fileName,
  imgSrc,
  imgType,
  certificateType,
  onComplete,
}) {
  const imgSrcAsBase64String = await getImgSrcAsBase64String(imgSrc);

  const bkgImgBytes = base64ToArrayBuffer(imgSrcAsBase64String);
  // console.log(bkgImgBytes);

  //
  html2canvas(document.querySelector(`#${id}`) as HTMLElement, {
    scale,
    allowTaint: true,
    useCORS: true,
    backgroundColor: null,
  }).then(canvas => {
    canvas.toBlob(async (blob: any) => {
      const newImg = document.createElement('img');

      const url = URL.createObjectURL(blob);

      newImg.onload = img => {
        URL.revokeObjectURL(url);
      };

      newImg.src = url;

      // document.body.appendChild(canvas);
      // return;

      let imgBytes = await blobToBase64(blob);

      imgBytes = base64ToArrayBuffer(
        (imgBytes as string).replace('data:image/png;base64,', '')
      );

      const pdfDoc = await PDFDocument.create();

      let embedImgType;
      //
      if (['png', 'PNG'].includes(imgType)) {
        embedImgType = 'embedPng';
      }

      if (['jpg', 'JPG', 'jpeg', 'JPEG'].includes(imgType)) {
        embedImgType = 'embedJpg';
      }

      if (imgType.toLowerCase() === 'svg') {
        embedImgType = 'embedSvg';
      }

      const bkgImg = await pdfDoc[embedImgType](bkgImgBytes);
      const img = await pdfDoc.embedPng(
        imgBytes as string | Uint8Array | ArrayBuffer
      );

      const page = pdfDoc.addPage([imgSize?.width || 0, imgSize?.height || 0]);

      certificateType === 'custom' &&
        page.drawImage(bkgImg, {
          x: 0,
          y: 0,
          width: imgSize?.width,
          height: imgSize?.height,
        });

      page.drawImage(img, {
        x: 0,
        y: 0,
        width: imgSize?.width,
        height: imgSize?.height,
      });

      const scale = 1024 / imgSize?.width;
      console.log('width: ', imgSize?.width, 'pdfScale res ? :', scale);

      page.scale(scale, scale);

      const pdfBytes = await pdfDoc.save();

      download(pdfBytes, `${fileName || 'Certificate'}.pdf`, 'application/pdf');

      onComplete();
    });

    //
  });
}

async function generatePDF(
  certificateImg: string,
  textFields: TextFieldData[],
  interactionName: string
) {
  const imgURL = certificateImg;
  // [
  //   'http://reviewsite.inspiregroup.co.nz/manual/TEMP/Certificate%20V2.svg',
  //   'https://cdnb.artstation.com/p/assets/images/images/039/374/867/large/darren-quach-stormland-assault-trooper-01-16x9-dq.jpg',
  // ][1];

  const imgBytes = await fetch(imgURL).then(res => res.arrayBuffer());

  const pdfDoc = await PDFDocument.create();

  const img = await pdfDoc.embedPng(imgBytes);
  const imgDimensions = img.scale(1);

  const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);
  const fontSize = 30;

  const page = pdfDoc.addPage([imgDimensions.width, imgDimensions.height]);

  const width = page.getWidth();
  const height = page.getHeight();

  console.log('pdf width :', {
    width,
    height,
  });

  page.drawImage(img, {
    x: 0,
    // page.getWidth() / 2 - imgDimensions.width / 2,
    y: 0,
    // page.getHeight() / 2 - imgDimensions.height / 2 + 250,
    width: width || imgDimensions.width,
    height: height || imgDimensions.height,
  });

  textFields.forEach(async tF => {
    const { text, x, y, width, height, fontFamily, fontSize } = tF;

    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    // page.drawRectangle({
    //   x,
    //   y,
    //   width,
    //   height,
    //   borderColor: rgb(1, 0, 0),
    //   borderWidth: 1.5,
    // });

    page.drawText(text, {
      x,
      y: y - height,
      size: fontSize,
      font,
      color: rgb(0, 0, 0),
    });
  });

  const pdfBytes = await pdfDoc.save();

  download(pdfBytes, `${interactionName}.pdf`, 'application/pdf');

  return pdfBytes;
}

export { generatePDF, generatePDFFromCanvas };
